import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { getDocumentFleetList, getDocumentFleetListSuccess, getDossierDetailsFleet, getPaperworksDetailsFleet, openDocumentFleetModal, getPurchasesDetailsFleet } from '../../../../actions/management/management'
import { openModal } from '../../../../actions/common'
import { openDocumentDetailsFleetModal } from '../../../../actions/management/auxModals/auxModals'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'
import DocumentsListComponent from '../../../../components/management/fleets/documents/DocumentsListComponent'
import TrackingContainer from '../../../tracking/trackingContainer'
import { openDocumentCreationModal } from '../../../../actions/dossier/common/documentEditionModal'

export function mapStateToProps (state) {
  return {
    ...state.management.documentsFleetComponent,
    dossierTypesCombo: state.combos.dossierTypesCombo,
    paperWorkCount: state.management.childSubtypeCount[dossierSubTypeId.tramite] || 0
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      openModal,
      getDocumentFleetList,
      getDocumentFleetListSuccess,
      openDocumentDetailsFleetModal,
      openDocumentCreationModal,
      getDossierDetailsFleet,
      getPaperworksDetailsFleet,
      openDocumentFleetModal,
      getPurchasesDetailsFleet
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(DocumentsListComponent, true)))
